import { Schemas } from '~/api/gen'
import { Chip } from '~/components/elements/Chip'
import { TitledChipList } from '~/components/modules/TitledChipList'
import { buildUrl } from '~/features/shared/search/coordinate/builder/buildUrl'

type Props = {
  nickName: string
  frequentlyUsedTags: Schemas.tag[]
}

export const FrequentlyUsedTags: React.FC<Props> = ({
  nickName,
  frequentlyUsedTags,
}) => {
  return (
    <TitledChipList title={`${nickName}がよく使用するタグ`}>
      {frequentlyUsedTags.map((tag) => (
        <li key={tag.id}>
          <Chip
            href={buildUrl({
              tagIds: [tag.id],
            })}
          >
            {`#${tag.name}`}
          </Chip>
        </li>
      ))}
    </TitledChipList>
  )
}
